import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  downloadText: {
    cursor: 'pointer',
  },
}));

export default useStyles;
